import React from 'react';
import { useAppSelector } from 'redux/hooks';

import { Button } from 'components/commons';
import { ModalBasic } from 'components/commons/Modals';
import { WithSelected } from "..";
import { ColumnChooser } from '..';

import burgerIcon from 'assets/images/burger-icon.svg';

import {IColumnData, IRowData} from "../../../../constants/Table/interfaces";

interface ITableProps {
  setPageSize: (pageSize: number) => void,
  selectedRows: object[],
  addColumn: (column: IColumnData) => void,
  deleteColumn: (column: IColumnData) => void,
  columns: Array<IColumnData>,
  deleteRow: (row: IRowData) => void,
  tableSettings: any,
  totalProducts: number,
  setTablePageSize: (pageSize: number) => void,
  setColumnData: (data: Array<IColumnData>) => void
}

function TableHeader({ setPageSize, selectedRows, addColumn, deleteColumn, columns, deleteRow, tableSettings, totalProducts, setTablePageSize, setColumnData }: ITableProps) {
  const [modalOpen, setModalOpen] = React.useState(false);

  const { currentSeller } = useAppSelector((state) => ({
    currentSeller: state.sellers.currentSeller,
  }));


  const modalOpenHanlder = (e: React.MouseEvent) => {
    e.stopPropagation();
    setModalOpen(true)
  }

  return (
    <>
      <header className="py-4 px-4 border-b border-slate-200">
        <div className="flex flex-col itens-start md:items-center md:flex-row md:justify-between">
          <div className="flex items-center">
            <Button clickHandler={modalOpenHanlder} customClassName="mr-3 open-modal">
              <img src={burgerIcon} alt="menu" />
            </Button>
            {currentSeller && <div className="text-gray-800 text-base font-semibold">{currentSeller.info.data?.sellerName}</div>}
          </div>
        </div>
        <div className="flex items-center">
          <WithSelected deleteRow={deleteRow} selectedRows={selectedRows} />
        </div>
      </header>
      <ModalBasic id="true" customSize="max-w-5xl" title="Выбор колонок таблицы" modalOpen={modalOpen} setModalOpen={setModalOpen}>
        <ColumnChooser setColumnData={setColumnData} addColumn={addColumn} deleteColumn={deleteColumn} columns={columns} />
      </ModalBasic>
    </>
  );
}

export default TableHeader;
